// 全局 echarts resize 管理器。
//
// 背景：原来每个图表（js.js 的 echarts_1/4/5/31、area_echarts 的地图、以及 Vue 组件里的
// echart6 / 分项指标饼图）都各自 window.addEventListener('resize', ...)，且基本不解绑。
// 数据轮询每隔几分钟重新建图就再绑一个，长时间运行后监听器会累积到成百上千个，
// 一次 F11 / 改窗口就触发全部，造成秒级卡顿。
//
// 这里改成所有图表共用「一个」resize / fullscreenchange 监听，并用 requestAnimationFrame
// 节流（同一帧多次 resize 事件只实际 resize 一次）。
//
// 既给 src 下的 Vue 组件 import 使用，也通过 window.__chartResize 暴露给
// public/assets/js 下的 jQuery 老脚本（js.js、area_echarts.js）。
// chart 实例 -> 可选的自定义 resize 回调（不传则调用 chart.resize() 自适应容器）
const charts = new Map();
let rafId = 0;
let bound = false;
function resizeAll() {
    rafId = 0;
    charts.forEach((customResize, chart) => {
        // 已 dispose 的实例再调用 resize 会抛错，顺手从集合里剔除（兼顾 Vue 组件卸载场景）
        if (typeof chart.isDisposed === "function" && chart.isDisposed()) {
            charts.delete(chart);
            return;
        }
        try {
            if (customResize) {
                customResize();
            }
            else {
                chart.resize();
            }
        }
        catch (e) {
            // 单个图表 resize 失败不应连累其它图表
            charts.delete(chart);
        }
    });
}
function scheduleResize() {
    // 同一帧内的多次 resize 事件只触发一次实际 resize
    if (rafId)
        return;
    rafId = requestAnimationFrame(resizeAll);
}
function ensureBound() {
    if (bound)
        return;
    bound = true;
    window.addEventListener("resize", scheduleResize);
    document.addEventListener("fullscreenchange", scheduleResize);
}
export function registerChart(chart, customResize) {
    if (!chart)
        return;
    ensureBound();
    charts.set(chart, customResize || null);
}
export function unregisterChart(chart) {
    charts.delete(chart);
}
// 暴露给 jQuery 老脚本
window.__chartResize = { registerChart, unregisterChart };
